import { COMMISSION_MATRIX_STATUS } from '../data/commission-matrix-status.data';
import { ECommMatrixVerifyStatus } from '../enums/commission-matrix-status.enum';

export type CommissionMatrixStatus = typeof COMMISSION_MATRIX_STATUS[number];
export type CommisisonMatrixVerifyStatus = `${ECommMatrixVerifyStatus}`;
